import React from 'react';
import Carousel from './Carousel';
import FeaturedCars from '../pages/FeaturedCars';
import BestPriceCars from '../pages/BestPriceCars';
import ServiceOffer from '../pages/ServiceOffer';
import CarLoanCalculator from '../pages/CarLoanCalculator';
import PopularVehicles from '../pages/PopularVehicles';
import Testimonials from '../pages/Testimonials';
import LatestBlogs from '../pages/LatestBlogs';



const HeroSection = () => {
  
  return (


    <div className="th-hero-wrapper hero-1" id="hero">



 <Carousel/>
<FeaturedCars/>
{/* <BestPriceCars/> */}
<ServiceOffer/>
<CarLoanCalculator/>
{/* <PopularVehicles/> */}
<Testimonials/>
<LatestBlogs/>

    </div>
  );
};

export default HeroSection;
